(function () {
  if (
    !window.location.pathname.includes("/collections") &&
    !window.location.pathname.includes("/products")
  ) {
    return;
  }
  function boostRotationOverrides() {
    document.querySelectorAll(".boost-sd__product-item").forEach((tile) => {
      const main = tile.querySelector(".boost-sd__product-image-img--main");
      const second = tile.querySelector(".boost-sd__product-image-img--second");

      if (main) {
        const mainSrc = (main.currentSrc || main.src || "").toLowerCase();

        if (mainSrc.includes("bck") || mainSrc.includes("back")) {
          if (tile.classList.contains("right-hand")) {
            main.style.setProperty("transform", "translate(-50%, -50%) rotate(90deg)", "important");
          } else if (tile.classList.contains("left-hand")) {
            main.style.setProperty("transform", "translate(-50%, -50%) rotate(-90deg)", "important");
          }
        }
      }

      if (!second) return;

      const secondSrc = (second.currentSrc || second.src || "").toLowerCase();
      if (!secondSrc.includes("frt")) return;

      if (tile.classList.contains("right-hand")) {
        second.style.setProperty("transform", "translate(-50%, -50%) rotate(-90deg)", "important");
      } else if (tile.classList.contains("left-hand")) {
        second.style.setProperty("transform", "translate(-50%, -50%) rotate(90deg)", "important");
      }
    });
  }

  function initObserver() {
    const grid = document.querySelector(".boost-sd__filter-product-list");
    const rec = document.querySelector(".boost-sd__recommendation");

    if (!grid && !rec) return false;

    boostRotationOverrides();

    const observer = new MutationObserver(() => {
      boostRotationOverrides();
    });

    if (grid) observer.observe(grid, { childList: true, subtree: true });
    if (rec) observer.observe(rec, { childList: true, subtree: true });

    return true;
  }

  if (!initObserver()) {
    const interval = setInterval(() => {
      if (initObserver()) clearInterval(interval);
    }, 300);

    setTimeout(() => clearInterval(interval), 10000);
  }
})();